module.exports = __webpack_public_path__ + "img/GO2Partners2023HorizRGB-WHT.70f2c51d.png";